define(function (require) {
    "use strict";

    var AcdController = require("personalization-web-agent-controllers/AcdController");
    var AcdEditController = require("personalization-web-agent-controllers/AcdEditController");
    var SLAController = require("personalization-web-agent-controllers/SLAController");
    var SLAEditController = require("personalization-web-agent-controllers/SLAEditController");
    var Privileges = require("codeTables/privileges.json");
    var IFrameIntegrationWidgetAnchorController = require("personalization-web-agent-controllers/IFrameIntegrationWidgetAnchorController");
    var WidgetListEditController = require("personalization-web-agent-controllers/WidgetListEditController");
    var ClickToDummyEngagementController = require("personalization-web-agent-controllers/ClickToDummyEngagementController");
    var ClickToVisitorPageMenuController = require("personalization-web-agent-controllers/ClickToVisitorPageMenuController");
    var AgentStateController = require("personalization-web-agent-controllers/AgentStateController");
    var AgentStateEditController = require("personalization-web-agent-controllers/AgentStateEditController");
    var EngagementAreaController = require("personalization-web-agent-controllers/EngagementAreaController");
    var CoBrowseConfigAnchorController = require("personalization-web-agent-controllers/CoBrowseConfigAnchorController");
    var CoBrowseConfigEditController = require("personalization-web-agent-controllers/CoBrowseConfigEditController");
    var AgentFileSharingAnchorController = require("personalization-web-agent-controllers/AgentFileSharingAnchorController");
    var AgentFileSharingEditController = require("personalization-web-agent-controllers/AgentFileSharingEditController");
    var CsatController = require("personalization-web-agent-controllers/CsatController");
    var CsatEditController = require("personalization-web-agent-controllers/CsatEditController");
    function FeaturesConfig() {

        //---------------------------features--------------------------
        var ACD_Configuration = {
            id:"ACD_Configuration",
            isEnabled: _isACD_ConfigurationEnabled,
            permissions: [Privileges.privilegeIDs.EDIT_ACD],
            anchorSelector: "div[data-personalization='ACD']",
            anchorController: AcdController,
            editController :AcdEditController
        };

        var SLA_AppConnectionsConfiguration = {
            id:"SLA_AppConnectionsConfiguration",
            isEnabled: _isMessagingEnabled,
            permissions: [Privileges.privilegeIDs.EDIT_UI_PERSONALIZATION],
            anchorSelector: "span[data-personalization='SLA']",
            anchorController: SLAController,
            editController :SLAEditController
        };

        var SLA_MyConnectionsConfiguration = {
            id:"SLA_MyConnectionsConfiguration",
            isEnabled: _isMessagingEnabled,
            permissions: [Privileges.privilegeIDs.EDIT_UI_PERSONALIZATION],
            anchorSelector: "span[data-personalization='SLA_MY_CONNECTIONS']",
            anchorController: SLAController,
            editController :SLAEditController
        };

        var defaultAgentStatus_Configuration = {
            id:"defaultAgentStatus_Configuration",
            isEnabled: _isDefaultAgentStatus_ConfigurationEnabled,
            permissions: [Privileges.privilegeIDs.EDIT_UI_PERSONALIZATION],
            anchorSelector: "div[data-personalization='DefaultAgentStatus']",
            anchorController: AgentStateController,
            editController :AgentStateEditController
        };

        var IFrameIntegration = {
            id:"IFrameIntegration",
            isEnabled: function(){return true;},
            permissions: [Privileges.privilegeIDs.EDIT_UI_PERSONALIZATION],
            anchorSelector: "div[data-personalization='WIDGETS']",
            anchorController: IFrameIntegrationWidgetAnchorController,
            editController :WidgetListEditController
        };

        var clickToDummyEngagement = {
            id:"clickToDummyEngagement",
            isEnabled: function(){return true;},
            permissions: [Privileges.privilegeIDs.EDIT_UI_PERSONALIZATION],
            anchorController: ClickToDummyEngagementController,
            editController :ClickToDummyEngagementController
        };
        var clickToVisitorPageMenu = {
            id:"clickToVisitorPageMenu",
            isEnabled: function(){return true;},
            permissions: [Privileges.privilegeIDs.EDIT_UI_PERSONALIZATION],
            anchorController: ClickToVisitorPageMenuController,
            editController :ClickToVisitorPageMenuController
        };

        var EngagementArea = {
            id:"engagementAreaFakeFeature",
            isEnabled: function(){return true;},
            permissions: [Privileges.privilegeIDs.EDIT_UI_PERSONALIZATION],
            anchorController: EngagementAreaController
        };

        var coBrowseConfig_Configuration = {
            id:"cobrowseConfig_Configuration",
            isEnabled: _isCoBrowseConfigEnabled,
            permissions: [Privileges.privilegeIDs.EDIT_UI_PERSONALIZATION],
            anchorController: CoBrowseConfigAnchorController,
            editController :CoBrowseConfigEditController
        };

        var agentFileSharing_Configuration = {
            id:"agentFileSharing_Configuration",
            isEnabled: _isAgentFileSharing_ConfigurationEnabled,
            permissions: [Privileges.privilegeIDs.EDIT_UI_PERSONALIZATION, Privileges.privilegeIDs.EDIT_API_KEYS_MANAGEMENT],
            anchorController: AgentFileSharingAnchorController,
            editController :AgentFileSharingEditController
        };

        var CSAT_AppConnectionsConfiguration = {
            id:"CSAT_AppConnectionsConfiguration",
            isEnabled: _isMessagingEnabled,
            permissions: [Privileges.privilegeIDs.EDIT_UI_PERSONALIZATION],
            anchorSelector: "span[data-personalization='CSAT']",
            anchorController: CsatController,
            editController :CsatEditController
        };

        var CSAT_MyConnectionsConfiguration = {
            id:"CSAT_MyConnectionsConfiguration",
            isEnabled: _isMessagingEnabled,
            permissions: [Privileges.privilegeIDs.EDIT_UI_PERSONALIZATION],
            anchorSelector: "span[data-personalization='CSAT_MY_CONNECTIONS']",
            anchorController: CsatController,
            editController :CsatEditController
        };

        //---------------------------features functions--------------------------

        //ACD should be enabled for migrating customers and not for legacy customers
        function _isACD_ConfigurationEnabled() {
            var isEnabled=false;
            if(LE.sessionManager && (LE.sessionManager.hasLiveEngage2Feature() || LE.sessionManager.hasMigratingFeature())){
                if(LE.siteSettings && LE.siteSettings.routingSourceSettings && LE.siteSettings.routingSourceSettings.getCurrentRoutingSource()==="LE"){
                    isEnabled=true;
                }
            }
            LE.LEPersonalization.logger.debug(isEnabled,"FeaturesConfig(web agent)._isACD_ConfigurationEnabled - isEnabled:"+isEnabled);
            return isEnabled;
        }

        //default status should not be enabled for migrating customers and for legacy customers
        function _isDefaultAgentStatus_ConfigurationEnabled() {
            return (LE.sessionManager && LE.sessionManager.hasLiveEngage2Feature());
        }


        function _isCoBrowseConfigEnabled(){
            return LE.sessionManager && LE.sessionManager.hasLiveEngage2Feature() && LE.sessionManager.hasCoBrowseFeature();
        }

        function _isMessagingEnabled() {
            return (LE.sessionManager && LE.sessionManager.hasAsyncMessagingFeature());
        }

        function _isAgentFileSharing_ConfigurationEnabled() {
            var config = !!LE.sessionManager && !!LE.sessionManager.getConfig && LE.sessionManager.getConfig();
            return !!config && !config.isLPA && !!_isMessagingEnabled();
        }

        var pages = {
            VisitorListTableViewController: [ACD_Configuration,clickToDummyEngagement,defaultAgentStatus_Configuration],
            ConnectionsLogTableViewController: [ACD_Configuration,clickToDummyEngagement,defaultAgentStatus_Configuration],
            AgentListTableViewController: [ACD_Configuration,clickToDummyEngagement,defaultAgentStatus_Configuration],
            MessagingAgentListTableViewController: [ACD_Configuration,clickToDummyEngagement,defaultAgentStatus_Configuration],
            EngagementsHistoryTableViewController: [ACD_Configuration,clickToDummyEngagement,defaultAgentStatus_Configuration],
            MyConnectionsListTableViewController: [ACD_Configuration,clickToDummyEngagement,defaultAgentStatus_Configuration,SLA_MyConnectionsConfiguration],//CSAT_MyConnectionsConfiguration],
            AppConnectionsListTableViewController: [ACD_Configuration,clickToDummyEngagement,defaultAgentStatus_Configuration,SLA_AppConnectionsConfiguration],//CSAT_AppConnectionsConfiguration],
            SimulatedEngagement:[clickToVisitorPageMenu,IFrameIntegration,coBrowseConfig_Configuration,agentFileSharing_Configuration],
            EngagementArea: [EngagementArea]
        };

        return {
            pages: pages
        };

    }

    return FeaturesConfig;
});
